import LegalDocPage from '@/components/legal/LegalDocPage';
import { useLanguage } from '@/contexts/LanguageContext';
import { getKvkkSections, KVKK_PATH } from '@/lib/legalContent';

const KvkkPage = () => {
  const { lang } = useLanguage();
  const isTr = lang === 'tr';

  return (
    <LegalDocPage
      lang={lang}
      canonical={KVKK_PATH}
      title={isTr ? 'KVKK Aydınlatma Metni' : 'KVKK Clarification Text'}
      subtitle={
        isTr
          ? '6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aydınlatma metni.'
          : 'Clarification notice under Turkish Law No. 6698 on Protection of Personal Data (KVKK).'
      }
      seoDescription={
        isTr
          ? 'Figtures KVKK aydınlatma metni: veri sorumlusu, işleme amaçları, aktarım, saklama ve ilgili kişi hakları.'
          : 'Figtures KVKK clarification: controller, purposes, transfers, retention, and data subject rights.'
      }
      sections={getKvkkSections(lang)}
    />
  );
};

export default KvkkPage;
